const routes = [
    {
        path: "/prep/exam/definitions",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "prepexamdefinition_index"
        }
    }
];

export default routes;
